import { Link } from "react-router-dom";
import Seo from "@/components/common/Seo";
import ManhuaCard from "@/components/feature/ManhuaCard";
import { manhuaList, categories, shuyuanList, faqList } from "@/mocks/manhua";

export default function Home() {
  const hotList = [...manhuaList].sort((a, b) => b.rating - a.rating).slice(0, 8);
  const latestList = [...manhuaList].slice(0, 4);
  const topShuyuan = shuyuanList.slice(0, 3);

  return (
    <>
      <Seo
        title="好看的韩漫大全 - 韩漫在线阅读站与免费网站推荐"
        description="好看的韩漫大全在线阅读站聚合多个免费网站资源，解决好看的韩漫大全哪个网站有的问题，推荐稳定收藏站点，支持下载与追更提醒，随时打开随时看。"
        keywords="好看的韩漫大全,好看的韩漫大全哪个网站有,好看的韩漫大全在线阅读站,好看的韩漫大全免费网站,好看的韩漫大全推荐站点"
        canonical="https://hkmans1.github.io/"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          name: "好看的韩漫大全",
          description: "聚合多个免费韩漫网站资源，提供在线阅读与稳定收藏站点推荐的韩漫大全平台。",
        }}
      />

      {/* Hero */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Stylized%20Korean%20webtoon%20manhwa%20illustration%20collage%2C%20dynamic%20heroes%20in%20action%20poses%20across%20a%20vibrant%20comic%20cityscape%2C%20vivid%20coral%20orange%20and%20amber%20palette%20with%20dark%20ink%20outlines%2C%20energetic%20youthful%20atmosphere%2C%20modern%20comic%20cover%20art%20style%2C%20high%20detail&width=1920&height=900&seq=hero-bg&orientation=landscape"
            alt="韩漫大全 在线阅读平台插画背景"
            className="h-full w-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/75" />
        </div>

        <div className="relative mx-auto flex w-full max-w-6xl flex-col items-center px-4 py-20 text-center md:py-28">
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-sm font-medium text-background-50 backdrop-blur">
            <i className="ri-fire-fill text-accent-500" />
            聚合免费书源 · 每日更新 · 追更不迷路
          </span>
          <h1 className="heading-font mt-6 text-3xl font-bold leading-tight text-background-50 md:text-5xl">
            好看的韩漫大全在线阅读站
          </h1>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-background-100/90 md:text-lg">
            还在纠结好看的韩漫大全哪个网站有？我们聚合多个稳定免费的韩漫在线阅读站，为你推荐靠谱收藏站点，支持随时打开随时看，热门新番一手掌握。
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/shuyuan"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
            >
              <i className="ri-magic-line" />
              查看免费书源推荐
            </Link>
            <Link
              to="/list"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-background-50/15 px-6 py-3 text-sm font-bold text-background-50 whitespace-nowrap backdrop-blur transition-colors hover:bg-background-50/25"
            >
              <i className="ri-compass-3-line" />
              浏览全部韩漫
            </Link>
          </div>
          <div className="mt-12 grid w-full max-w-3xl grid-cols-3 gap-4">
            {[
              { num: "2000+", label: "收录作品" },
              { num: "30+", label: "聚合书源" },
              { num: "24h", label: "实时更新" },
            ].map((s) => (
              <div key={s.label} className="rounded-xl bg-background-50/10 p-4 backdrop-blur">
                <p className="text-2xl font-bold text-accent-500 md:text-3xl">{s.num}</p>
                <p className="mt-1 text-xs text-background-100 md:text-sm">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 热门榜单 */}
      <section className="mx-auto w-full max-w-6xl px-4 py-12 md:py-16">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <h2 className="heading-font text-2xl font-bold text-foreground-950 md:text-3xl">本周热门韩漫</h2>
            <p className="mt-2 text-sm text-foreground-600">读者口碑与人气双高的好看韩漫，先看这里准没错</p>
          </div>
          <Link to="/list" className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700">
            查看全部 <i className="ri-arrow-right-line" />
          </Link>
        </div>
        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4">
          {hotList.map((m) => (
            <ManhuaCard key={m.id} item={m} />
          ))}
        </div>
      </section>

      {/* 题材分类 */}
      <section className="w-full bg-background-100/70">
        <div className="mx-auto w-full max-w-6xl px-4 py-12 md:py-16">
          <h2 className="heading-font text-2xl font-bold text-foreground-950 md:text-3xl">按题材找好漫</h2>
          <p className="mt-2 text-sm text-foreground-600">分类挑选，快速锁定你喜欢的风格</p>
          <div className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4">
            {categories.map((c, i) => (
              <Link
                key={c}
                to={`/list?cat=${encodeURIComponent(c)}`}
                className="group flex items-center gap-3 rounded-xl bg-background-50 p-4 transition-colors hover:bg-primary-500"
              >
                <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-100 text-primary-600 transition-colors group-hover:bg-background-50/20 group-hover:text-background-50">
                  <i className={i % 2 === 0 ? "ri-sword-fill text-lg" : "ri-heart-3-fill text-lg"} />
                </span>
                <div>
                  <p className="text-sm font-bold text-foreground-950 transition-colors group-hover:text-background-50">{c}</p>
                  <p className="text-xs text-foreground-600 transition-colors group-hover:text-background-100">{i % 2 === 0 ? "冒险燃向" : "治愈甜向"}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* 免费书源推荐 */}
      <section className="mx-auto w-full max-w-6xl px-4 py-12 md:py-16">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <h2 className="heading-font text-2xl font-bold text-foreground-950 md:text-3xl">免费韩漫网站推荐</h2>
            <p className="mt-2 text-sm text-foreground-600">解决“好看的韩漫大全哪个网站有”，推荐稳定收藏站点</p>
          </div>
          <Link to="/shuyuan" className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700">
            全部书源 <i className="ri-arrow-right-line" />
          </Link>
        </div>
        <div className="mt-8 grid gap-4 md:grid-cols-3">
          {topShuyuan.map((s) => (
            <div key={s.id} className="flex flex-col rounded-xl border border-background-200/70 bg-background-100 p-5">
              <div className="flex items-center gap-3">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-accent-100 text-accent-700">
                  <i className={`${s.icon} text-xl`} />
                </span>
                <div>
                  <p className="font-bold text-foreground-950">{s.name}</p>
                  <span className="text-xs text-primary-600">{s.tag}</span>
                </div>
              </div>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">{s.desc}</p>
              <div className="mt-4 flex flex-wrap items-center gap-2 text-xs">
                <span className="rounded-full bg-secondary-100 px-2.5 py-1 text-secondary-900">免费</span>
                <span className="rounded-full bg-secondary-100 px-2.5 py-1 text-secondary-900">稳定 {s.stability}%</span>
                {s.download && <span className="rounded-full bg-secondary-100 px-2.5 py-1 text-secondary-900">支持下载</span>}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* 最新更新 */}
      <section className="w-full bg-background-100/70">
        <div className="mx-auto w-full max-w-6xl px-4 py-12 md:py-16">
          <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
            <div>
              <h2 className="heading-font text-2xl font-bold text-foreground-950 md:text-3xl">最新追更</h2>
              <p className="mt-2 text-sm text-foreground-600">收藏本站，最新一话更新第一时间跟进</p>
            </div>
            <Link to="/list" className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700">
              查看更多 <i className="ri-arrow-right-line" />
            </Link>
          </div>
          <div className="mt-8 grid gap-4 md:grid-cols-2">
            {latestList.map((m) => (
              <Link
                key={m.id}
                to={`/detail/${m.id}`}
                className="group flex gap-4 rounded-xl border border-background-200/70 bg-background-50 p-4 transition-colors hover:border-primary-300"
              >
                <div className="h-32 w-24 shrink-0 overflow-hidden rounded-lg bg-background-200">
                  <img src={m.cover} alt={`${m.title} 韩漫封面`} className="h-full w-full object-cover object-top" />
                </div>
                <div className="flex flex-col justify-center gap-1.5">
                  <h3 className="heading-font text-lg font-bold text-foreground-950 group-hover:text-primary-600">{m.title}</h3>
                  <p className="text-xs text-foreground-600">{m.category} · {m.author}</p>
                  <p className="text-sm font-semibold text-primary-600">{m.latestChapter} 已更新</p>
                  <p className="text-xs text-foreground-500">{m.updateTime}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* 常见问题 */}
      <section className="mx-auto w-full max-w-6xl px-4 py-12 md:py-16">
        <h2 className="heading-font text-2xl font-bold text-foreground-950 md:text-3xl">常见问题</h2>
        <p className="mt-2 text-sm text-foreground-600">关于韩漫在线阅读与书源使用的常见疑问</p>
        <div className="mt-8 grid gap-3 md:grid-cols-2">
          {faqList.slice(0, 4).map((f) => (
            <details key={f.q} className="group rounded-xl border border-background-200/70 bg-background-100 p-5">
              <summary className="flex cursor-pointer list-none items-center justify-between gap-3 text-sm font-bold text-foreground-950">
                {f.q}
                <i className="ri-add-line text-lg text-foreground-500 transition-transform group-open:rotate-45" />
              </summary>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{f.a}</p>
            </details>
          ))}
        </div>
        <div className="mt-6 text-center">
          <Link to="/faq" className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700">
            查看全部常见问题 <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </section>

      {/* CTA */}
      <section className="mx-auto w-full max-w-6xl px-4 pb-14">
        <div className="relative overflow-hidden rounded-2xl">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20Korean%20webtoon%20style%20sunset%20background%20with%20dynamic%20ink%20swirls%20and%20floating%20comic%20panels%2C%20warm%20coral%20orange%20and%20golden%20amber%20gradient%2C%20energetic%20youthful%20comic%20art%20backdrop%2C%20high%20detail&width=1600&height=500&seq=cta-bg&orientation=landscape"
              alt="韩漫大全 在线阅读背景装饰"
              className="h-full w-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/80 to-foreground-950/40" />
          </div>
          <div className="relative flex flex-col items-start gap-4 px-6 py-12 md:px-12 md:py-16">
            <h2 className="heading-font text-2xl font-bold text-background-50 md:text-3xl">把好看的韩漫大全收藏起来</h2>
            <p className="max-w-xl text-sm leading-relaxed text-background-100 md:text-base">
              一个收藏站点，多个免费书源聚合，热门新番与经典佳作随时打开随时看，追更提醒不遗漏。
            </p>
            <Link
              to="/shuyuan"
              className="inline-flex items-center gap-2 rounded-full bg-accent-500 px-6 py-3 text-sm font-bold text-foreground-950 whitespace-nowrap transition-colors hover:bg-accent-600"
            >
              <i className="ri-star-smile-line" />
              立即开始阅读
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}